import { render, staticRenderFns } from "./RepeatCard.vue?vue&type=template&id=df8f4c22&scoped=true&"
import script from "./RepeatCard.vue?vue&type=script&lang=ts&"
export * from "./RepeatCard.vue?vue&type=script&lang=ts&"
import style0 from "./RepeatCard.vue?vue&type=style&index=0&id=df8f4c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8f4c22",
  null
  
)

export default component.exports